import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useEditedQuestionIndicator, useErrorQuestionIndicator } from "../../../../_shared/hooks";
import { useSendCustomMailSettingForCheckInBefore_00days } from "../../../api/send-custom-mail-setting/check-in-before-00-days";
import { useSendCustomMailSettingForCheckInBefore_01days } from "../../../api/send-custom-mail-setting/check-in-before-01-days";
import { useSendCustomMailSettingForCheckInBefore_07days } from "../../../api/send-custom-mail-setting/check-in-before-07-days";
import { MailTemplateItem } from "../_shared/mail-template-item";

import type { BasicCustomMailSettingFormData } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<BasicCustomMailSettingFormData>;
	hotelID: string;
};

export const ForCheckInRemind = ({ form, hotelID }: Props) => {
	const {
		watch,
		setValue,
		formState: { errors },
	} = form;

	const oneWeekBeforeValue = watch("forReservation.atCheckInBefore_07days.text");
	const oneDayBeforeValue = watch("forReservation.atCheckInBefore_01days.text");
	const todayValue = watch("forReservation.atCheckInBefore_00days.text");

	// 値が入っているかどうかを監視（設定した項目がある場合に青丸を表示）
	useEditedQuestionIndicator("1週間前", Boolean(oneWeekBeforeValue));
	useEditedQuestionIndicator("前日", Boolean(oneDayBeforeValue));
	useEditedQuestionIndicator("当日", Boolean(todayValue));

	// バリデーションエラーがある場合に赤丸を表示
	useErrorQuestionIndicator("1週間前", Boolean(errors.forReservation?.atCheckInBefore_07days?.text));
	useErrorQuestionIndicator("前日", Boolean(errors.forReservation?.atCheckInBefore_01days?.text));
	useErrorQuestionIndicator("当日", Boolean(errors.forReservation?.atCheckInBefore_00days?.text));

	const { sendTestMailAtCheckInBefore07Days } = useSendCustomMailSettingForCheckInBefore_07days();
	const { sendTestMailAtCheckInBefore01Days } = useSendCustomMailSettingForCheckInBefore_01days();
	const { sendTestMailAtCheckInBefore00Days } = useSendCustomMailSettingForCheckInBefore_00days();

	return (
		<div className="space-y-6">
			<div className="ml-2">
				{/* 一週間前 */}
				<MailTemplateItem
					hidePreviewButton={false}
					label={"1週間前"}
					dialogTitle={"1週間前"}
					value={oneWeekBeforeValue || ""}
					errorMessage={errors.forReservation?.atCheckInBefore_07days?.text?.message || ""}
					handleChange={(value) =>
						setValue(
							"forReservation.atCheckInBefore_07days.text", //
							value,
							{ shouldDirty: true, shouldValidate: true },
						)
					}
					sendTestEmail={async ({ email }) => {
						await sendTestMailAtCheckInBefore07Days({
							email,
							content: oneWeekBeforeValue || "",
							hotelId: hotelID,
							langCode: LangCode.En,
						});
					}}
					lang={LangCode.Default}
					hotelEmailAddress=""
				/>

				{/* 前日 */}
				<MailTemplateItem
					hidePreviewButton={false}
					label={"前日"}
					dialogTitle={"前日"}
					value={oneDayBeforeValue || ""}
					errorMessage={errors.forReservation?.atCheckInBefore_01days?.text?.message || ""}
					handleChange={(value) =>
						setValue(
							"forReservation.atCheckInBefore_01days.text", //
							value,
							{ shouldDirty: true, shouldValidate: true },
						)
					}
					sendTestEmail={async ({ email }) => {
						await sendTestMailAtCheckInBefore01Days({
							email,
							content: oneDayBeforeValue || "",
							hotelId: hotelID,
							langCode: LangCode.En,
						});
					}}
					lang={LangCode.Default}
					hotelEmailAddress=""
				/>

				{/* 当日 */}
				<MailTemplateItem
					hidePreviewButton={false}
					label={"当日"}
					dialogTitle={"当日"}
					value={todayValue || ""}
					errorMessage={errors.forReservation?.atCheckInBefore_00days?.text?.message || ""}
					handleChange={(value) =>
						setValue(
							"forReservation.atCheckInBefore_00days.text", //
							value,
							{ shouldDirty: true, shouldValidate: true },
						)
					}
					sendTestEmail={async ({ email }) => {
						await sendTestMailAtCheckInBefore00Days({
							email,
							content: todayValue || "",
							hotelId: hotelID,
							langCode: LangCode.En,
						});
					}}
					lang={LangCode.Default}
					hotelEmailAddress=""
				/>
			</div>
		</div>
	);
};
